module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/transform.js
// module id = 1929
// module chunks = 0